import { render, staticRenderFns } from "./placeOrder.vue?vue&type=template&id=e67420d2&scoped=true"
import script from "./placeOrder.vue?vue&type=script&lang=js"
export * from "./placeOrder.vue?vue&type=script&lang=js"
import style0 from "./placeOrder.vue?vue&type=style&index=0&id=e67420d2&prod&lang=css"
import style1 from "./placeOrder.vue?vue&type=style&index=1&id=e67420d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67420d2",
  null
  
)

export default component.exports